export default __webpack_public_path__ + "images/GM.5f38b98.png";